<template>
    <div class="col-sm-10 offset-sm-1 col-lg-8 offset-lg-2">
        <div class="tile">
            <div class="text-center py-4">
                <template v-if="!isLoggedIn">
                    <p class="h5 mb-4">Log in to access this page.</p>
                    <a class="btn btn-primary" :href="loginUrl">Log in</a>
                </template>
                <p v-else class="h5 mb-4">This page is unavailable.</p>
                <Promised :promise="getUrl('index')" v-slot:combined="{ data: resolvedUrl }">
                    <a class="btn btn-outline-secondary" @click.prevent="changePage({ page: 'Index' })" :href="resolvedUrl">Home</a>
                </Promised>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import { asyncComputed } from "@vueuse/core";
import { Promised } from "vue-promised";
import { useMainStore } from "@/mainStore";
import { changePageInjectKey, getLoginUrlInjectKey } from "@/AppShell.3.vue.InjectKeys";
export default defineComponent({
    components: {
        Promised,
    },
    setup() {
        const mainStore = useMainStore();
        const getLoginUrl = inject(getLoginUrlInjectKey)!;
        return {
            isLoggedIn: asyncComputed(() => mainStore.isLoggedInPromise),
            getUrl: mainStore.getUrl,
            changePage: inject(changePageInjectKey)!,
            loginUrl: asyncComputed(() => getLoginUrl()),
        };
    },
});
</script>
